/**
 * Factures établies à partir d'une formation encodée dans la base.
 *
 * Le montant facturé est celui que le secrétariat a saisi sur l'inscription
 * (`montant`, `montantKukkiwon`) : le recalculer à partir d'un barème ferait
 * courir le risque qu'une facture contredise ce qui est encodé.
 *
 * Module pur : la numérotation est injectée, rien n'est lu ni écrit ici.
 */

import {factureVierge, ligneVierge, normaliser} from './modele'
import {normaliserMontant} from './calculs'

function nomComplet (membre) {
  return [membre.nom, membre.prenom].filter(Boolean).join(' ').trim()
}

function intituleFormation (formation) {
  return [formation.titre, formation.dateFR].filter(Boolean).join(' — ')
}

function ligne (description, prixUnitaire) {
  return Object.assign(ligneVierge(), {
    description: description,
    quantite: 1,
    prixUnitaire: normaliserMontant(prixUnitaire)
  })
}

/**
 * Une facture par inscription retenue. Les inscriptions sans membre sont
 * ignorées : une facture sans destinataire n'aurait pas de sens.
 */
export function facturesDepuisFormation (formation, inscriptions, parametres) {
  const options = parametres || {}
  const numeroter = options.numeroter || function () { return '' }
  const source = formation || {}

  return (inscriptions || [])
    .filter(function (inscription) { return inscription && inscription.membre })
    .map(function (inscription) {
      const membre = inscription.membre
      const facture = normaliser(factureVierge())

      facture.numero = numeroter()
      facture.client = Object.assign({}, facture.client, {
        source: 'membre',
        idSource: membre.id || null,
        nom: nomComplet(membre),
        adresse: membre.adresse || '',
        cp: membre.cp || '',
        ville: membre.ville || '',
        email: membre.mail || ''
      })

      facture.lignes = [ligne(intituleFormation(source), inscription.montant)]

      // Le diplôme Kukkiwon est commandé d'office pour un 1er dan et sur
      // demande au-delà : l'inscription porte déjà l'information
      if (inscription.kukkiwon) {
        const grade = inscription.diplome && inscription.diplome.grade
        facture.lignes.push(ligne(
          ['Diplôme Kukkiwon', grade].filter(Boolean).join(' — '),
          inscription.montantKukkiwon
        ))
      }

      facture.origine = {
        type: 'formation',
        idFormation: source.id || null,
        idInscription: inscription.id || null
      }

      return facture
    })
}

export default {facturesDepuisFormation}



// WEBPACK FOOTER //
// ./src/utils/facture/formation.js